import type { IPopup } from "@mm-frontend/mm-web-ui-kit";
import { SignInProfileFillingStepForm } from "./SignInProfileFillingStepForm";
import { ref } from "vue";

export class SignInProfileFillingStepController {
  public popup: IPopup;
  public form: SignInProfileFillingStepForm;
  public formData;
  public isLoading = ref(false);

  constructor({ popup }: { popup: IPopup }) {
    this.popup = popup;
    this.form = new SignInProfileFillingStepForm();
    this.formData = this.form.formData;
  }
}